import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import Box, { BoxProps } from '../ui/Box';
import Txt from '../ui/Txt';
import * as styles from './PageHeader.css';

export type PageLabelProps = BoxProps;

export const PageLabel = ({ children, ...props }: PageLabelProps) => {
  return (
    <Box {...mergePropsClassName(props, styles.pageLabel)}>
      <Txt uppercase variant="tiny">
        {children}
      </Txt>
    </Box>
  );
};
